import { DEFAULT_LAYERS } from "../constants";
import { migrateToV2 } from "./V2Migrator";

const migrateToV3 = (currentData, data) => {
    currentData = currentData.version === 2
        ? currentData
        : migrateToV2(currentData, data);

    currentData.layers = DEFAULT_LAYERS;
    migrateElementsToV3(currentData.elements, currentData.species);
    currentData.showMigrationMessage = true;

    return currentData;
}

const migrateElementsToV3 = (elements = [], species = {}) => {
    elements.forEach((element) => {
        element.data.layer = getLayerFromSpecies(element.speciesIds, species);
        element.data.addedDate = null;
        element.data.removedDate = null;
    });
}

const getLayerFromSpecies = (speciesIds = [], species = {}) => {
    for (const id of speciesIds) {
        const s = species[id];
        if (!s) continue;
        if (!s['Layer']) continue;
        if (Array.isArray(s['Layer'])) {
            if (s['Layer'].length) return s['Layer'][0];
        } else {
            return s['Layer'];
        }
    }
    return null;
}

export { migrateToV3 };
